module.exports = __webpack_public_path__ + "img/jah-jireh.ec6f7edc.svg";